// 子仓库 - 客服管理
import to from 'await-to-js';
import * as apis from "@/api/interface/kefu";

export default {
  namespaced: true,
  state: () => ({
    callInRecordList: undefined, //通话数据统计 - 列表
    immediateStatusList: undefined, //客服实时状态 - 列表
    ctrList: undefined, //通话录音查询 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 通话数据统计 - 列表
    async getCallInRecordList(ctx, payload = {}) {
      const [err, res] = await to (apis.getCallInRecordList(payload));
      ctx.commit("update", {
        callInRecordList: !err && res.data ? res.data : undefined,
      });
    },
    // 通话数据统计 - 客服选项
    async getCallinSeatOptions(_, payload = {}) {
      const [, res] = await to (apis.getCallinSeatOptions(payload));
      return res;
    },

    
    // 客服名称 - 选项
    async getKfNameOptions(ctx, payload = {}) {
      const [, res] = await to (apis.getKfNameOptions(payload));
      return res;
    },
    // 客服实时状态 - 列表
    async getImmediateStatusList(ctx, payload = {}) {
      const [err, res] = await to (apis.getImmediateStatusList(payload));
      ctx.commit("update", {
        immediateStatusList: !err && res.data ? res.data : undefined,
      });
    },
    // 通话录音查询 - 列表
    async getCtrList(ctx, payload = {}) {
      const [err, res] = await to (apis.getCtrList(payload));
      ctx.commit("update", {
        ctrList: !err && res.data ? res.data : undefined,
      });
    },
  },
  modules: {},
};
